<template>
  <div class="recommend">
    <h4>
      展品推荐
      <span @click="$router.push('/exhibitor')">更多</span>
    </h4>
    <div class="wrapper" ref="wrapper">
      <ul class="recommendList" ref="ulWidth">
        <li v-for="(item,i) in list" :key="i">
          <div>
            <img :src="item.url" alt=""/>
          </div>
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
    <div class="showWinning" @click="$jumpWeb('https://www.cippe.com.cn/prize/')">
      <img src="http://www.cippe.com.cn/miniprogram/jinjiang.gif" alt=""/>
    </div>
  </div>
</template>

<script>
// import BScroll from 'better-scroll'
export default {
  data () {
    return {
      list:[
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian01.jpg",
          name:"BR2800Q油田压裂专用泵"
        },
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian02.jpg",
          name:"Superbolt超级螺栓"
        },
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian03.jpg",
          name:"IIB铸钢防爆接线盒"
        },
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian04.jpg",
          name:"S-PDC钻头系列"
        },
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian05.jpg",
          name:"防爆式试管清洗机"
        },
        {
          url:"http://www.cippe.com.cn/miniprogram/tuijian06.jpg",
          name:"振动筛"
        },
      ]
    }
  },
  mounted(){
    // 元素宽度需要动态获取
    // this.$refs.ulWidth.style.width= 100*this.list.length+"px"
    // this.$nextTick(() => {
    //   this.scroll = new BScroll(this.$refs.wrapper, {
    //     scrollX:true,
    //     click: true
    //   })
    // })
  }
}
</script>

<style scoped>
.wrapper{
  overflow: hidden;
  width: 100%;
}
.recommendList{
  /* width: 100%; */
  height: 150px;
  /* overflow: hidden; */
  white-space: nowrap;
  overflow-x: auto;
}
.recommendList li{
  display: inline-block;
  width: 90px;
  margin: 0 10px;
  /* box-sizing:border-box; */
  text-align: center;
  vertical-align: top;
}
.recommendList li:first-child{
  margin-left: 0;
}
.recommendList li div{
  width: 90px;
  height: 90px;
  overflow: hidden;
  box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: white;
}
.recommendList li p{
  white-space:pre-wrap;
  margin-top: 10px;
  padding:0 2px;
  line-height: 20px;
  font-size: 12px;
}
.showWinning{
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
}
.showWinning img{
  width: 100%;
}
</style>